module.exports = __webpack_public_path__ + "static/media/iDocBrowser_portfolio_image.eae661e3.jpg";